import { SecondaryNavKey } from '../models/secondary-nav-key';
import { SecondaryNavOption } from '../models/secondary-nav-option';
import { actionsFactory, props } from '@ngneat/effects';

const secondaryNavActions = actionsFactory('secondary-nav');

export const setSecondaryNavOptions = secondaryNavActions.create(
  'Set The List Of Secondary Nav Options',
  props<{ key: SecondaryNavKey; options: SecondaryNavOption[] }>()
);
